module.exports = __webpack_public_path__ + "img/Club-slider6-subscriptions-amico.a2d9eb2d.png";